import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FileResponse } from '../model/file';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(
    private http: HttpClient
  ) {}

  getReportSaving(surveyId: string,): Observable<FileResponse> {
    return this.http.get<FileResponse>(environment.api.report + '/' + surveyId + '/savings');
  }

  getReportPrevidence(surveyId: string,): Observable<FileResponse> {
    return this.http.get<FileResponse>(environment.api.report + '/' + surveyId + '/previdence');
  }

  getReportProtection(surveyId: string,): Observable<FileResponse> {
    return this.http.get<FileResponse>(environment.api.report + '/' + surveyId + '/protection');
  }

  getReportQuestionnaire(surveyId: string,): Observable<FileResponse> {
    return this.http.get<FileResponse>(environment.api.report + '/' + surveyId + '/questionnaire');
  }
}
